var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgResourceCenter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.1904 11.4818C17.922 11.4818 20.1344 9.26931 20.1344 6.53775C20.1344 3.80619 17.922 1.59375 15.1904 1.59375C12.4588 1.59375 10.2464 3.80619 10.2464 6.53775C10.2464 9.26931 12.4588 11.4818 15.1904 11.4818ZM15.1904 4.06575C16.55 4.06575 17.6624 5.17815 17.6624 6.53775C17.6624 7.89735 16.55 9.00975 15.1904 9.00975C13.8308 9.00975 12.7184 7.89735 12.7184 6.53775C12.7184 5.17815 13.8308 4.06575 15.1904 4.06575ZM15.1904 14.6336C12.2734 11.9144 8.36769 10.2458 4.06641 10.2458V23.8418C8.36769 23.8418 12.2734 25.5103 15.1904 28.2296C18.1074 25.5227 22.0131 23.8418 26.3144 23.8418V10.2458C22.0131 10.2458 18.1074 11.9144 15.1904 14.6336ZM23.8424 21.5304C20.7153 21.9507 17.7489 23.1372 15.1904 25.016C12.6442 23.1372 9.66549 21.9383 6.53841 21.5181V12.9279C9.13401 13.3976 11.5442 14.5965 13.5094 16.4258L15.1904 18.0078L16.8714 16.4381C18.8366 14.6088 21.2468 13.4099 23.8424 12.9402V21.5304Z",
    fill: "#8F8F8F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResourceCenter);
export default __webpack_public_path__ + "static/media/resourceCenter.ba639f9a859dbda915f7249ee7ec9284.svg";
export { ForwardRef as ReactComponent };